export const settingslist = [
  {
    id: 1,
    settingtitle: "Alert",
    settingsvalue: "5 minutes",
  },
  {
    id: 2,
    settingtitle: "Email",
    settingsvalue: "gowrip@tendersoftware.in",
  },
]

export const companylist = [
  {
    id: 1,
    companyname: "Mecondan Groups",
    settingtitle: "Alert",
    settingsvalue: "5 minutes",
  },
  {
    id: 2,
    companyname: "Mopo Life inc",
    settingtitle: "Email",
    settingsvalue: "mopo@tendersoftware.in",
  },
]

export const employeelist = [
  {
    id: 1,
    employeename: "Mathew",
    settingtitle: "Alert",
    settingsvalue: "5 minutes",
  },
  {
    id: 2,
    employeename: "Andrew",
    settingtitle: "Email",
    settingsvalue: "andrew@tendersoftware.in",
  },
]

export const employeeList = [
  {
    id: 1,
    name: "Andrew",
    email: "andrew@tendersoftware.in",
    phone: "987654321",
  },
  {
    id: 2,
    name: "Mathew",
    email: "mathew@tendersoftware.in",
    phone: "987654321",
  },
  {
    id: 3,
    name: "John",
    email: "andrew@tendersoftware.in",
    phone: "987654321",
  },
  {
    id: 4,
    name: "Lisa",
    email: "mathew@tendersoftware.in",
    phone: "987654321",
  },

  // {
  //   id: 3,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
  // {
  //   id: 4,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
  // {
  //   id: 5,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
]

export const companyList = [
  {
    id: 1,
    companyname: "Licensys",
    contactname: "Luke",
    companyemail: "andrew@tendersoftware.in",
    companyphone: "987654321",
    projectname: "Licensys UI",
  },
  {
    id: 2,
    companyname: "infotool",
    contactname: "Alex",
    companyemail: "mathew@tendersoftware.in",
    companyphone: "987654321",
    projectname: "Angular UI",
  },
  {
    id: 3,
    companyname: "BFM",
    contactname: "Luke",
    companyemail: "andrew@tendersoftware.in",
    companyphone: "987654321",
    projectname: "BFM UI",
  },
  {
    id: 4,
    companyname: "SKM",
    contactname: "Sankar",
    companyemail: "mathew@tendersoftware.in",
    companyphone: "987654321",
    projectname: "UI",
  },

  // {
  //   id: 3,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
  // {
  //   id: 4,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
  // {
  //   id: 5,
  //   settingtitle: "Alert",
  //   settingsvalue: "5 minutes",
  // },
]

export const Reasondropdown = [
  {
    id: 1,
    label: "Meeting",
    value: "Meeting",
  },
  {
    id: 2,
    label: "Network Outage",
    value: "Network Outage",
  },
  {
    id: 3,
    label: "App Crash",
    value: "App Crash",
  },
  {
    id: 4,
    label: "Others",
    value: "Others",
  },
]

export const customStylesSelect = {
  option: (provided, state) => ({
    ...provided,
    // color: state.isSelected ? 'white' : 'black',
    background: state?.isSelected ? "#e69138" : "white",
    "&:hover": {
      background: "#f4c896", // Change option background color on hover
      color: "#fff", // Change option text color on hover
    },
    ':hover': {
        backgroundColor: state.isDisabled && 'transparent',
        color:'gray'
    }
  }),
}
export const emailDomains = [""]

export const reportStatus = [
  // { id: 1, label: "Ready", value: "Ready" },
  { id: 2, label: "Submitted", value: "Submitted" },
  { id: 3, label: "Report Not Submitted", value: "Report Not Submitted" },
  // { id: 4, label: "Screen Not Verified", value: "Screen Not Verified" },
]

export const billingType = [
  { id: 0, label: "All", value: "All" },
  { id: 1, label: "Non Client", value: "Non Client" },
  { id: 2, label: "Client", value: "Client" },
]

export const reportStatussummary = [
  { id: 1, label: "Sent", value: "Sent" },
  { id: 2, label: "Not sent", value: "Not sent" },
]

export const quotedtypesummary = [
  { id: 2, label: "Non Quoted", value: "Non Quoted" },
  { id: 3, label: "Quoted", value: "Quoted" },
]

export const setModeCompact = [
  { id: 1, label: "Compact View", value: "Compact View" },
  { id: 2, label: "Full View", value: "Full View" },
]

export const hoursList = [
  {
    label: "Active",
    value: "Active",
    dataField: "activeHours",
  },
  {
    label: "Idle",
    value: "Idle",
    dataField: "idleHours",
  },
  {
    label: "Break",
    value: "Break",
    dataField: "breakHours",
  },
  {
    label: "Private",
    value: "Private",
    dataField: "privateHours",
  },
  {
    label: "On Evaluation",
    value: "On Evaluation",
    dataField: "onEvaluationHours",
  },
]
export const hoursListteam = [
  {
    label: "Active",
    value: "Active",
    dataField: "activeHours",
  },
  {
    label: "Idle",
    value: "Idle",
    dataField: "idleHours",
  },
  {
    label: "Break",
    value: "Break",
    dataField: "breakHours",
  },
  {
    label: "Private",
    value: "Private",
    dataField: "privateHours",
  },
  {
    label: "On Evaluation",
    value: "On Evaluation",
    dataField: "onEvaluationHours",
  },
]

export const hoursReportStatus = [
  {
    id: 1,
    label: "Daily Employee hours",
    value: "Daily Employee hours",
  },
  {
    id: 2,
    label: "Project hours summary",
    value: "Project hours summary",
  },
  {
    id: 3,
    label: "Employee hour summary",
    value: "Employee hour summary",
  },
 {
    id: 5,
    label: "Evaluation hours",
    value: "Evaluation hours",
 },
 {
    id: 6,
    label: "Unapproved Evaluation hours",
    value: "Unapproved Evaluation hours",
 }
]
export const SupervisorReportStatus = [
  {
    id: 3,
    label: "Normal",
    value: "Normal",
  },
  {
    id: 4,
    label: "Supervisor",
    value: "Supervisor",
  },
]

export const dropdownWorkfromHomeList = [
  {
    id: 1,
    label: "Detailed work",
    value: "Detailed work",
  },
  {
    id: 2,
    label: "Summary of work",
    value: "Summary of work",
  },
]
export const dropdownWfhsiftList = [
  {
    id: 0,
    label: "All",
    value: "All",
  },
  {
    id: 1,
    label: "First Half",
    value: "First Half",
  },
  {
    id: 2,
    label: "Second Half",
    value: "Second Half",
  },
  {
    id: 3,
    label: "Full Day",
    value: "Full Day",
  },
  {
    id: 4,
    label: "Partial Login",
    value: "Partial Login",
  },
]
